// CONTATO NA BARRA DO TOPO — quais tenants mostram o telefone/WhatsApp no cabeçalho das
// variantes que nasceram sem ele.
//
// O topo "Clássico" (modelo_topo = 1, 2.180 sites) sempre mostrou telefones/WhatsApp ao lado
// das redes. As variantes editoriais nasceram só com logo + menu + redes — e o cs2631
// (#1447, Montevero) escolheu o "Editorial fixo" e pediu o número visível na barra.
//
// Por que allowlist e não geral: 17 sites usam o modelo_topo = 6 e escolheram esse cabeçalho
// pelo desenho enxuto que ele tem hoje. Ligar para todos mudaria a cara deles sem pedido.
// Para liberar mais um tenant, some o id aqui (uma linha) — para liberar geral, troque o
// `has(...)` por `true` e apague a lista.
export const TOPO_CONTATO_CODSITES = new Set([2631, 2656]);

/** Mostra o contato na barra do topo editorial? Fora da lista, o cabeçalho fica como sempre foi. */
export function mostraContatoNoTopo(site: any): boolean {
  return TOPO_CONTATO_CODSITES.has(Number(site?.id));
}

// TELEFONES NO LUGAR DO MENU (cs2639 CASAMAIS+, pedido de 16/09/2026).
//
// O cliente pediu o topo editorial SEM os links "Comprar", "Alugar" e "Blog" (montados sozinhos
// a partir das transações e do 1º post — não há chave no painel para desligá-los) e, no lugar
// deles, os DOIS telefones do cadastro: ícone de WhatsApp em quem tem `telN_whats`, ícone de
// telefone no outro. Números e ícones das redes em azul marinho (cor2 da marca) e o botão de
// menu (☰) logo à direita das redes, visível também no computador — é a única navegação que sobra.
//
// Allowlist e não regra geral: nos outros sites deste topo os links de texto são o caminho
// para as listagens no computador (lá o ☰ só aparece até 900px).
export const TOPO_TELEFONES_NO_LUGAR_DO_MENU = new Set<number>([2639]);

/** true = topo editorial sem menu de texto, com tel1/tel2 no lugar e ☰ visível em qualquer largura. */
export function mostraTelefonesNoLugarDoMenu(site: any): boolean {
  return TOPO_TELEFONES_NO_LUGAR_DO_MENU.has(Number(site?.id));
}

// ÍCONES DE REDE DO MENU LATERAL NA COR DO TEXTO (cs2639, 16/09/2026). O menu lateral desenha
// Instagram/Facebook/YouTube com `fill="#fff"` fixo — some quando o fundo do menu (cor10) é
// claro. O cs2639 pediu o menu branco com letras azul-marinho; para ele os ícones seguem a cor
// das letras do menu. Nos demais sites o ícone continua branco, como sempre foi.
export const MENU_ICONES_NA_COR_DO_TEXTO = new Set<number>([2639]);

/** true = ícones de rede do menu lateral usam a cor das letras do menu em vez de branco. */
export function menuIconesNaCorDoTexto(site: any): boolean {
  return MENU_ICONES_NA_COR_DO_TEXTO.has(Number(site?.id));
}

// TOPO FIXO AO ROLAR (cs2639, 21/09/2026). O cliente pediu a faixa branca do topo acompanhando a
// rolagem. Vale no topo Clássico (components/pieces/topo/Topo.tsx — home e listagens) e na cópia
// dele que a página do imóvel usa (properties/welcome2/WelcomePiecesProperties.tsx). Nos demais
// sites o topo rola junto com a página, como sempre.
export const TOPO_FIXO_AO_ROLAR = new Set<number>([2639]);

/** true = o topo fica preso no alto da tela ao rolar. */
export function topoFixoAoRolar(site: any): boolean {
  return TOPO_FIXO_AO_ROLAR.has(Number(site?.id));
}

// ÍCONE DO TELEFONE FIXO NA COR DA MARCA (cs2639, 21/09/2026). O topo Clássico desenha o número
// que não é WhatsApp com um PNG cinza-escuro (assets/images/iconTelephone.png). O cs2639 pediu o
// ícone no azul da logo. Quem está no mapa recebe o ícone vetorial nessa cor; o WhatsApp segue verde
// e os demais sites continuam com o PNG de sempre.
export const TOPO_ICONE_TELEFONE_COR: Record<number, string> = {
  2639: '#344175',
};

/** Cor do ícone de telefone (não WhatsApp) do topo, ou null = PNG padrão. */
export function corIconeTelefoneTopo(site: any): string | null {
  return TOPO_ICONE_TELEFONE_COR[Number(site?.id)] || null;
}

// "EMPREENDIMENTOS" NO MENU LATERAL E NA COLUNA "NAVEGAÇÃO" DO RODAPÉ (cs2639, 21/09/2026).
// Item logo abaixo das transações ("Imóveis para alugar"), levando à listagem /condominios — a
// mesma do "Ver todos" da seção de empreendimentos da home. Só para quem pediu, e só quando o site
// exibe empreendimentos (`exibir_empreendimento`).
export const LINK_EMPREENDIMENTOS_NO_MENU = new Set<number>([2639]);

/** true = menu lateral e rodapé mostram o link "Empreendimentos" depois das transações. */
export function mostraLinkEmpreendimentos(site: any): boolean {
  return LINK_EMPREENDIMENTOS_NO_MENU.has(Number(site?.id)) && !!site?.exibir_empreendimento;
}

// NÚMEROS DE TELEFONE EM NEGRITO NO CABEÇALHO (cs2639, 25/09/2026). Só o número fica em negrito;
// o rótulo embaixo ("Plantão de Vendas", "Comercial") continua no peso normal. Vale no topo
// Clássico (Topo.tsx) e na cópia dele da página do imóvel (welcome2/WelcomePiecesProperties.tsx).
export const TOPO_NUMEROS_EM_NEGRITO = new Set<number>([2639]);

/** true = os números de telefone do cabeçalho saem em negrito (sem o rótulo). */
export function numerosDoTopoEmNegrito(site: any): boolean {
  return TOPO_NUMEROS_EM_NEGRITO.has(Number(site?.id));
}

// TÍTULO DA PÁGINA DO IMÓVEL NA COR DA LOGO (cs2639, 25/09/2026). O H1 da ficha (gallery3, usada
// pelos modelos de página 3 e 4) sai no cinza-escuro fixo do CSS; o cs2639 pediu o azul da logo.
export const TITULO_IMOVEL_COR: Record<number, string> = {
  2639: '#344175',
};

/** Cor do H1 da página do imóvel, ou null = cor padrão do CSS. */
export function corTituloImovel(site: any): string | null {
  return TITULO_IMOVEL_COR[Number(site?.id)] || null;
}

// "VER NO MAPA" AO LADO DO ENDEREÇO DO RODAPÉ (cs2639, 25/09/2026). Abre a imobiliária no Google
// Maps: usa o link do Maps cadastrado no CRM (`url_maps`, o mesmo do "Como chegar" das páginas
// Empresa) e, sem ele, uma busca pelo endereço do rodapé.
export const RODAPE_VER_NO_MAPA = new Set<number>([2639, 2656]);

/** Link do Google Maps para o "Ver no mapa" do rodapé, ou null = sem link. */
export function linkVerNoMapaRodape(site: any, enderecoLinha: string): string | null {
  if (!RODAPE_VER_NO_MAPA.has(Number(site?.id))) return null;
  const urlMaps = String(site?.url_maps || '').trim();
  if (/^https?:\/\//i.test(urlMaps)) return urlMaps;
  if (!enderecoLinha) return null;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(enderecoLinha)}`;
}

// ☰ DO TOPO EDITORIAL VISÍVEL TAMBÉM NO COMPUTADOR, SEM TIRAR O MENU DE TEXTO (cs2656 Imovida,
// 01/10/2026). Neste topo o ☰ só aparece até 900px; o cs2656 pediu o menu lateral sempre à mão,
// mantendo os links "Comprar/Blog/…" da barra. (No cs2639 o ☰ aparece porque o menu de texto sai.)
export const TOPO_MENU_LATERAL_SEMPRE = new Set<number>([2656]);

/** true = o ☰ do topo editorial aparece em qualquer largura, junto do menu de texto. */
export function menuLateralSempreNoTopo(site: any): boolean {
  return TOPO_MENU_LATERAL_SEMPRE.has(Number(site?.id));
}

// TOPO ENXUTO + MENU LATERAL AGRUPADO (cs2606 Marcello & Oliveira, 01/10/2026). O topo editorial
// mostrava Comprar, Alugar e TODAS as páginas do cliente (Política, Anuncie, Trabalhe Conosco,
// Perguntas frequentes, Blog) + 5 redes — poluído. Para quem está aqui, a barra fica só com
// Comprar · Alugar · Empreendimentos · botão "Anuncie seu imóvel" · busca · ☰, e o ☰ abre um menu
// lateral próprio (direita, em grupos), em vez do menu lateral comum. Política de Privacidade sai do
// topo e do menu — continua no rodapé. Celular: logo, busca e ☰.
// `institucional` = título do grupo das páginas da empresa.
export const TOPO_ENXUTO: Record<number, { institucional: string }> = {
  2606: { institucional: 'Marcello & Oliveira' },
};

/** Config do topo enxuto com menu lateral agrupado, ou null = topo editorial de sempre. */
export function topoEnxuto(site: any): { institucional: string } | null {
  return TOPO_ENXUTO[Number(site?.id)] || null;
}

// "COMO QUER SER CHAMADO" + CANAIS DE CONTATO + "SEJA UM CORRETOR" NO MENU LATERAL (cs2656 Imovida,
// 01/10/2026). O visitante informa o nome e escolhe o canal (SMS, WhatsApp, ligação ou e-mail); a
// mensagem já sai assinada com o nome. Abaixo, um formulário curto "Seja um corretor" que vira lead
// pelo relay /api/site-form. O valor do mapa é o id da Página do Site (CRM) que guarda a config
// desse formulário (sitePageFormConfig) — página oculta, criada só para isso.
export const MENU_CONTATO_VISITANTE: Record<number, { paginaCorretor: number; blocoCorretor: string }> = {
  2656: { paginaCorretor: 4494, blocoCorretor: 'leadForm-7-b3' },
};

/** Config do bloco "como quer ser chamado" do menu lateral, ou null = site sem o bloco. */
export function menuContatoVisitante(site: any): { paginaCorretor: number; blocoCorretor: string } | null {
  return MENU_CONTATO_VISITANTE[Number(site?.id)] || null;
}

/**
 * Link `sms:` com o texto já preenchido. O separador do corpo muda por sistema: o iOS só aceita
 * `&body=`, o Android (e o resto) `?body=`. Mesma regra de DDI do `buildContatoTopoUrl`.
 */
export function buildSmsUrl(telefone: string | null | undefined, texto: string, userAgent = ''): string {
  const limpo = String(telefone ?? '').replace(/\D/g, '');
  if (!limpo) return '';
  const comDDI = limpo.length > 11 ? limpo : `55${limpo}`;
  const sep = /iphone|ipad|ipod|macintosh/i.test(userAgent) ? '&' : '?';
  return `sms:+${comDDI}${sep}body=${encodeURIComponent(texto)}`;
}

/**
 * Link de contato do cabeçalho — MESMA regra do `buildContactUrl` do topo Clássico
 * (components/pieces/topo/Topo.tsx): só dígitos, DDI 55 quando o número é nacional
 * (11 dígitos ou menos, já com DDD) e, no WhatsApp, o link curto do tenant quando existir.
 *
 * `resolveWhats` é injetado pelo componente (utils/site2524WhatsApp) para este util não
 * arrastar dependência de tenant específico.
 */
export function buildContatoTopoUrl(params: {
  telefone: string | null | undefined;
  ehWhatsapp: boolean;
  texto: string;
  resolveWhats?: (fallback: string) => string;
}): string {
  const limpo = String(params.telefone ?? '').replace(/\D/g, '');
  if (!limpo) return '';
  const comDDI = limpo.length > 11 ? limpo : `55${limpo}`;
  if (!params.ehWhatsapp) return `tel:+${comDDI}`;
  const fallback = `https://api.whatsapp.com/send?phone=${comDDI}&text=${encodeURIComponent(params.texto)}`;
  return params.resolveWhats ? params.resolveWhats(fallback) : fallback;
}

// cs2644 (07/10/2026): número do topo em UMA linha — a coluna fixa de 150px do Topo Clássico (e da
// cópia welcome2 da ficha) quebrava "(11) 99466-" / "4305" quando a fonte do navegador do visitante
// é maior que a padrão. Só para quem pediu; nos demais sites a coluna segue como está.
export const TOPO_NUMERO_EM_UMA_LINHA = new Set<number>([2644]);

export function numeroDoTopoEmUmaLinha(site: any): boolean {
  return TOPO_NUMERO_EM_UMA_LINHA.has(Number(site?.id));
}

// 3º TELEFONE NO TOPO (Topo Clássico e a cópia welcome2 da ficha/internas). Por padrão o topo mostra
// só tel1 e tel2; o tel3 cadastrado em Dados da empresa aparece no rodapé e no menu lateral. Quem
// pediu o 3º número também no cabeçalho: cs2537 e cs2551 (antes fixos no Topo.tsx) e cs2059 (Yes ABC,
// SD-0046, 29/10/2026: canal de parcerias para imobiliárias e corretores). Liberar outro = somar o id.
export const TOPO_TERCEIRO_TELEFONE = new Set<number>([2537, 2551, 2059]);

export function mostraTerceiroTelefoneNoTopo(site: any): boolean {
  return TOPO_TERCEIRO_TELEFONE.has(Number(site?.id));
}

// WHATSAPP E LIGAR NO MESMO NÚMERO, NO CELULAR (cs1859 Mister Imóveis, SD-0020 / sugestão #212, 02/11/2026).
// A marca "WhatsApp?" é do NÚMERO (tbl_portabilidade_numeros): o mesmo número não consegue ser WhatsApp
// num campo e ligação no outro. E no celular o telefone nem aparece no topo (.flex1 some até 850px; só o
// ☰ e a logo ficam). Quem está aqui ganha, nessa faixa, os botões WhatsApp + Ligar do tel1
// (components/pieces/topo/WhatsELigarCelular.tsx). No computador o topo segue igual.
// Só vale com o tel1 marcado como WhatsApp: sem a marca o número do topo já é um link de ligar.
export const TOPO_WHATS_E_LIGAR_NO_CELULAR = new Set<number>([1859]);

export function mostraWhatsELigarNoCelular(site: any): boolean {
  return TOPO_WHATS_E_LIGAR_NO_CELULAR.has(Number(site?.id)) && !!site?.Dados?.tel1 && !!site?.Dados?.tel1_whats;
}
